export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/1376265d92690fd518e46d698aec8208.png";